<template>
  <el-container class="indexhome">
    <el-header>
      <img
        class="logo"
        src="../assets/logo.svg">
      <p>{{$t('global.parentTitle')}}</p>
    </el-header>
    <el-main>
      <!-- 设置邮箱和推荐码 -->
      <div class="email_form">
        <el-form :model="emailForm" :rules="emailValidate" ref="emailForm" label-width="100px" class="demo-emailForm">
          <h3>{{$t('email.accountInfo')}}</h3>
          <p style="margin-top:40px;">{{$t('email.ParentFullName')}}</p>
          <el-form-item prop="name">
            <el-input :class="changeFlag == 1?'':'errorPass'" v-model="emailForm.name" autocomplete="off" maxlength='50'></el-input>
          </el-form-item>
          <p style="margin-top:40px;">{{$t('email.emailAddress')}}</p>
          <el-form-item prop="email">
            <el-input :class="changeFlag == 1?'':'errorPass'" type="email" v-model="emailForm.email" autocomplete="off" placeholder="example@email.com"></el-input>
          </el-form-item>
          <p style="margin-top:40px;">{{$t('email.WechatID')}}</p>
          <el-form-item prop="wechat">
            <el-input :class="changeFlag == 1?'':'errorPass'" v-model="emailForm.wechat" autocomplete="off" :placeholder="$t('email.nowechatname')"></el-input>
          </el-form-item>
          <!-- <p style="margin-top:40px;">{{$t('email.referralCode')}}</p>
          <el-form-item prop="code">
            <el-input :class="changeCodeFlag == 1?'':'errorPass'" :disabled="emailForm.isHavecode" type="text" v-model="emailForm.code" autocomplete="off" :placeholder="$t('email.entercode')"></el-input>
          </el-form-item> -->
          <span
          class="huo"
          @click="chooseCode"
          v-if="code==''"
          >{{$t('email.ReferredByFriend')}}</span>
          <p v-else class="codeTips">🎉 {{code}} Referral Code Applied!<i class="el-icon-error" @click="toClear"></i></p>
          <el-button type="primary" @click="toNext()">{{$t('global.next')}}</el-button>
        </el-form>
      </div>
      
      <div v-if="dialogFormVisible" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
        <div class="el-message-box">
          <div class="el-message-box__header">
            <div class="el-message-box__title center">
              <b>{{$t('email.FriendReferralPrograms')}}</b>
            </div>
            <button type="button" class="el-message-box__headerbtn" @click="chooseCode">
              <i class="el-message-box__close el-icon-close"></i>
            </button>
          </div>
          <div class="el-message-box__content">
            <div class="el-message-box__container">
              <div class="el-message-box__message">
                <p>{{$t('email.EnterYourReferralCode')}}</p>
                <el-input v-model="emailForm.code" autocomplete="off" :placeholder="$t('email.EnterCode')"></el-input>
              </div>
            </div>
          </div>
          <div class="el-message-box__btns">
            <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitCode">
              <span>{{$t('main.send')}}</span>
            </button>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'email',
  data () {
    const checkEmail = async (rule, value, callback) => {
      const mailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      // /^([a-zA-Z0-9_-])+([\.]([a-zA-Z0-9]+)?)*@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      // /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (!value) {
        return callback(new Error(this.$t('errorprompt.emailEmpty')))
      } else if (!mailReg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.emailError')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    const checkName = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('errorprompt.nameEmpty')))
      }else {
        this.changeFlag = 1
        callback()
      }
    }
    const checkWechat = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('errorprompt.wechatEmpty')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }

    // 密码验证
    // const pwdCheck = async (rule, value, callback) => {
    //   let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/
    //   if (!reg.test(value) && value != '') {
    //     this.changeCodeFlag = 2
    //     return callback(new Error(this.$t('errorprompt.referralError')))
    //   } else {
    //     this.changeCodeFlag = 1
    //     callback()
    //   }
    // }
    return {
      userInfo: {},
      emailForm: {
        wechat:'',
        name:'',
        email: '',
        code: '',
        isHavecode: false
      },
      emailValidate: {
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ],
        name: [
          { required: true, validator: checkName, trigger: 'blur' }
        ],
        // code: [
        //   { required: true, validator: pwdCheck, trigger: 'blur' }
        // ]
      },
      changeFlag: 1,
      changeCodeFlag: 1,
      dialogFormVisible: false,
      code:'',
      
    }
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/email'
        })
      } else {
        this.$router.push({
          path: '/index'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    this.userInfo = getStore(keys.userInfo)
    if (this.userInfo.referer_code && this.userInfo.referer_code != '') {
      this.emailForm.code = this.userInfo.referer_code
      this.emailForm.isHavecode = true
    }
    if (this.userInfo.email && this.userInfo.email != '') {
      this.emailForm.email = this.userInfo.email
    }
  },
  methods: {
    toNext () {
      this.$refs.emailForm.validate((valid, msg) => {
        if (!valid) {
          this.$message(msg['email'][0].message)
          return false
        }
        let form =  {
          name:this.emailForm.name,
          wechat:this.emailForm.wechat,
          email: this.emailForm.email 
        }
        if(this.code){
          form.inviteCode = this.code;
        }
        this.$http.post('/api/parent/saveEmail',form).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.data,
              type: 'success'
            })
            this.$router.push({ path: '/addChild' })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      })
    },
    //校验推荐码是否可应用
    submitCode(){
      if(this.emailForm.code==''){
        this.$message({
          message: this.$t('email.EnterYourReferralCode'),
          type: 'error'
        })
        return false;
      }
      this.$http.post('/api/verifyInvitationCode', {
          code: this.emailForm.code
        }).then((res) => {
          if (res.data.code == 200) {
            if(res.data.data.result){//推荐码可应用
              this.code = this.emailForm.code
              this.chooseCode()
            }else{
              //推荐码无效
              this.$message({
                message: this.$t('email.fail'),
                type: 'warning'
              })
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
    },
    //切换弹框
    chooseCode () {
      this.dialogFormVisible = !this.dialogFormVisible
    },
    //清除当前的推荐码
    toClear(){
      this.emailForm.code = ''
      this.code = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .indexhome{
    width: 1200px;
    height:auto!important;
    margin: 0 auto;
  }
  .el-header{
      width: 1200px;
      height:auto!important;
      padding: 20px 0;
      font-family: Sofia Pro-Regular;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      color: #353643;
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        width: 227px;
        margin-top:5px;
        text-align: center;
      }
  }
  .el-main{
    overflow: inherit;
    padding:0;
    h3{
      font-size: 18px;
      font-family: Sofia Pro-Bold;
      font-weight: 700;
      color: #353643;
      margin-top:10px;
    }
    p{
      font-size: 16px;
      font-family: Sofia Pro-Regular;
      color: #424347;
      margin-top:6px;
    }
    .email_form{
        width: 60%;
        margin: 0 auto;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        .el-form {
            width: 57%;
            height: 100%;
            margin: 0 auto 0 auto;
            padding:40px;
            display: flex;
            flex-direction: column;

            /deep/ .el-form-item{
                .el-form-item__content{
                  display: flex;
                  margin:0!important;
                  img{
                    width: 20px;
                    height:20px;
                    margin: 0 8px;
                    position: absolute;
                    right: 0px;
                    bottom:12px;
                  }
                  .el-input{
                    width: 100%;
                    border-bottom: 1px solid #a5a5a5;
                  }
                  .errorPass{
                    border-bottom: 1px solid #fc424c;
                  }
                  .el-input__inner {
                    -moz-appearance: none;
                    // width:100%;
                    height: 40px;
                    border:none;
                    background: none;
                    font-size: 16px;
                    color: #353643;
                    font-family: Sofia Pro-Regular;
                    letter-spacing: 0px;
                    outline: 0;
                    padding:0 40px 0 0;
                    border-radius: 0;
                  }
                  .el-form-item__error{
                    // margin-top:7px;
                    font-size: 14px;
                    color: #fc424c;
                    font-family: Sofia Pro-Regular;
                    width: max-content;
                  }
                }
              }

            .huo {
              font-size: 16px;
              font-family: Sofia Pro-Bold;
              font-weight: 700;
              text-decoration: underline;
              text-align: center;
              color: #ff6440;
              cursor: pointer;
              margin-top:40px;
              display: contents;
              display: block;
              width:100%;

            }
            .codeTips{
              width:100%;
              text-align: center;
              font-size: 18px;
              i{
                font-size: 24px;
                color:#4B69FE;
                cursor: pointer;
              }
            }
            button{
              width: 310px;
              height: 50px;
              background: #4B69FE;
              border-radius: 50px;
              border: 1px solid #4B69FE;
              // margin-top: 40px;
              // margin-bottom: 15px;
              margin: 20px auto 15px auto;
              color: #fff;
              font-weight: bold;
              font-size: 18px;
              font-family: Sofia Pro-Bold;
              box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20), 0px 1px 6px 1px rgba(81,124,255,0.20);
            }
        //     .borderBtn{
        //         width:auto;
        //         height: 40px;
        //         background: #ffffff;
        //         border: 2px solid #ff6440;
        //         border-radius: 7px;
        //         font-size: 14px;
        //         font-family: Sofia Pro-Bold;
        //         font-weight: 700;
        //         color: #ff6440;
        //         margin: 0 20px;
        //         &:hover{
        //           background: #ffffff;
        //           border: 2px solid #ff6440;
        //           font-size: 14px;
        //           font-family: Sofia Pro-Bold;
        //           font-weight: 700;
        //           color: #ff6440;
        //         }
        //     }
            input{
              width:345px;
              height: 50px;
              border:none;
              background: none;
              font-size: 18px;
              color: #353643;
              font-family: Sofia Pro-Regular;
              letter-spacing: 0px;
            }
            input:focus {
              outline: none;
            }
          }
        }
        .el-message-box{
          background: #FAFAFA;
          box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
          border-radius: 14px;
          .el-message-box__header{
            padding: 25px 84px;
            .el-message-box__title{
              margin-bottom:10px;
              font-size: 24px;
            }
            .el-message-box__headerbtn{
              top:25px;
            }
          }
          .el-message-box__content{
            color:#353643;
            padding: 22px 130px 50px;
            .el-message-box__message{
              .el-input{
                  width: 100%;
                  border-bottom: 1px solid #a5a5a5;
                }
                .errorPass{
                  border-bottom: 1px solid #fc424c;
                }
                /deep/ .el-input__inner {
                  -moz-appearance: none;
                  // width:100%;
                  height: 40px;
                  border:none;
                  background: none;
                  font-size: 16px;
                  color: #353643;
                  font-family: Sofia Pro-Regular;
                  letter-spacing: 0px;
                  outline: 0;
                  padding:0 40px 0 0;
                  border-radius: 0;
                }
              >p{
                margin-bottom: 10px;
                font-weight: bold;
              }
            }
          }
          .el-message-box__btns button{
            height: 60px;
            background: #4B69FE;
            border-radius: 50px;
            font-size: 18px;
            color: #FFFFFF;
            border:none;
          }
        }
    
  }

</style>



// WEBPACK FOOTER //
// src/components/email.vue